import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import Logo from '@/components/Logo';
import { useLanguage } from '@/contexts/LanguageContext';

const CONTACT = {
  phone: '+370 600 60388',
  email: 'groupmaisiagala@gmail.com',
};

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      className="bg-[#0A0A0A] border-t border-[#262626] mt-32"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo variant="stacked" className="items-start" />
          <p className="mt-8 text-sm text-white/60 leading-relaxed max-w-sm">
            {t('home.tagline')}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-gold mb-6">
            {t('nav.contact')}
          </div>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <Phone size={14} strokeWidth={1.5} className="text-gold mt-1" />
              <a href={`tel:${CONTACT.phone}`} className="hover:text-gold" data-testid="footer-phone">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={14} strokeWidth={1.5} className="text-gold mt-1" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-gold" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={14} strokeWidth={1.5} className="text-gold mt-1 flex-shrink-0" />
              <span data-testid="footer-address">{t('contact.info.address_value')}</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-gold mb-6">
            {t('nav.about')}
          </div>
          <ul className="space-y-3 text-sm">
            {[
              { to: '/about', key: 'about' },
              { to: '/investments', key: 'investments' },
              { to: '/real-estate', key: 'real_estate' },
              { to: '/asset-management', key: 'asset_management' },
              { to: '/contact', key: 'contact' },
            ].map((i) => (
              <li key={i.key}>
                <Link
                  to={i.to}
                  className="text-white/70 hover:text-gold transition-colors"
                  data-testid={`footer-link-${i.key}`}
                >
                  {t(`nav.${i.key}`)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#262626]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40">
          <div>
            © {year} UAB MAIŠIAGALA GROUP. {t('footer.rights')}
          </div>
          <div className="tracking-[0.2em] uppercase">{t('footer.privacy')}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
